// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, post } from "./api_client";
import { GenerateLaneLinesResult, IGenerateLaneLinesResult, GenerateLaneLinesRequest, IGenerateLaneLinesRequest } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function generate(facilityId?: string, request?: GenerateLaneLinesRequest): ApiResult<GenerateLaneLinesResult> {
	return post<IGenerateLaneLinesResult>(`/api/lanegeneration/${ facilityId }/generate-lane-lines`, request).then(result => result === undefined ? undefined :  new GenerateLaneLinesResult(result));
}
